import { Box, styled } from '@mui/material';

export const AuthContainer = styled(Box)(({ theme }) => ({
    padding: '2.25rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'unset',
    width: '600px',

    '&>*': {
        marginBottom: '2rem !important',

        '&:last-child': {
            marginBottom: '0 !important',
        },
    },

    [theme.breakpoints.down('sm')]: {
        padding: '0',
        alignItems: 'center',
        width: '100%',

        '&>*': {
            marginBottom: '1rem !important',
    
            '&:last-child': {
                marginBottom: '0 !important',
            },
        },
    },
}));
